"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
exports.default = {
    root: {
        width: `calc(100vw - ${constants_1.ATC_X_PADDING * 2}px)`,
        maxWidth: constants_1.ATC_GROUP_WIDTH,
        minWidth: constants_1.ATC_GROUP_MIN_WIDTH,
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0,
        padding: '14px 7px',
        boxSizing: 'border-box'
    }
};
//# sourceMappingURL=atc.group.style.js.map